import * as React from "react";
import {FieldWrapper} from "../FieldWrapper";
import { OutlinedContainer } from "../../../../../../../Components/Form/OutlinedContainer";
import moment from "moment";
import { DataTable } from "./DataTable";
import { TransactionValidationErrors, TransactionValidationField } from "../../../../../../../../validators/transactions";

export interface ISubTransaction {
    amount: number;
    date: moment.Moment;
    description: string;
}

export interface ISubTransactionOutput {
    amount: number;
    date: string;
    description: string;
}

interface ISubTransactionsFieldProps {
    value?: ISubTransaction[];
    onChange(value: ISubTransaction[]): void;
    onDelete(): void;
    errors?: TransactionValidationErrors;
}

export const SubTransactionsField = ({value, onChange, onDelete, errors}: ISubTransactionsFieldProps) => {
    return (
        <FieldWrapper onDelete={onDelete}>
            <OutlinedContainer label="Sub transactions" errors={errors?.get(TransactionValidationField.SUB_TRANSACTIONS)}>
                <DataTable
                    value={value || []}
                    onChange={onChange}
                />
            </OutlinedContainer>
        </FieldWrapper>
    );
}
